import { useNavigate } from "react-router-dom";
import configData from "../../config.json";
import { useMediaQuery } from "react-responsive";

const DailyActivity = () => {
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px)" && "(max-width: 1023px)",
  });
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });
  const wrapper = {
    marginLeft: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    marginRight: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    paddingLeft: isMobile ? "16px" : isTabScreen ? "20px" : "40px",
    paddingRight: isMobile ? "16px" : isTabScreen ? "20px" : "40px",
    paddingBottom: "40px",
    background: "#FBFBFB",
    borderRadius: "12px",
    paddingTop: isMobile ? "20px" : "28px",
    marginBottom: "40px",
    boxShadow: "0 6px 20px rgba(16, 24, 40, 0.05)",
  };
  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={wrapper}>
          <div
            style={{
              fontSize: "13px",
              fontWeight: "600",
              color: configData.THEME_COLORS.PRIMARY,
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
            onClick={() => {
              navigate({
                pathname: "/patient/Garbha_Sanskar",
                state: 1,
              });
            }}
          >
            {"\u2190"} Back
          </div>

          <div
            style={{
              marginTop: "12px",
              fontSize: isMobile ? "20px" : "24px",
              fontWeight: "600",
              color: configData.THEME_COLORS.SECONDARY,
            }}
          >
            Activity of the Day
          </div>
          <div
            style={{
              fontSize: isMobile ? "18px" : isTabScreen ? "20px" : "22px",
              fontWeight: "600",
              marginTop: "28px",
            }}
          >
            Activity Name
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "400",
              marginTop: "15px",
              color: "#4A5568",
              lineHeight: "1.7",
              maxWidth: "900px",
            }}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </div>

          <img
            src={"/GarbhaSanskar/Youtube-player.png"}
            style={{
              height: isMobile ? "220px" : isTabScreen ? "320px" : "450px",
              width: "100%",
              maxWidth: "900px",
              marginTop: "28px",
              marginBottom: "20px",
              borderRadius: "12px",
              objectFit: "cover",
            }}
            alt="Activity video preview"
          ></img>
        </div>
      </div>
    </>
  );
};

export default DailyActivity;
